import { CardSharingItem, InsuredWallet } from '.';

export type {
  InsuredWallet,
  CardSharingItem,
  ExternalAccessWallet,
  CreateSharingResponse,
  ApiResponse,
} from '../../../services/cardSharingService';

export interface SharedPerson {
  id: string;
  name: string;
  phone: string;
  avatar?: string;
}

export interface SharedCard {
  id: string;
  holderName: string;
  cardNumber: string;
  sharedWith: SharedPerson[];
}

export interface SharedCardWithApiData extends SharedCard {
  apiData?: {
    sharingId: string;
    token: string;
    sharingDate: string;
    expirationDate: string;
    status: string;
    allowsEdit: boolean;
    allowsDelete: boolean;
  };
}

export interface CardGroup {
  cardNumber: string;
  holderName: string;
  sharings: CardSharingItem[];
}

export interface CardSharingState {
  loading: boolean;
  error: string | null;
  sharedCards: SharedCard[];
  availableWallets: InsuredWallet[];
}

export interface CreateInsuredSharingRequest {
  userUnimedId: string;
  sharedUserUnimedId: string;
}

export interface CreateExternalSharingRequest {
  cpf: string;
  name: string;
  sharedUserUnimedId: string;
}

// eslint-disable-next-line no-shadow
export enum SharingType {
  INSURED = 'insured',
  EXTERNAL = 'external',
}

export interface SharingModalData {
  isOpen: boolean;
  type: SharingType | null;
  selectedCard: InsuredWallet | null;
}
